import CopyOutlined from "@ant-design/icons/lib/icons/CopyOutlined";
import { Tooltip } from "antd";
import * as React from "react";
import toast from "../Toast";

const MAX_LENGTH = 20;
const HEAD_LENGTH = 10;
const TAIL_LENGTH = 8;

/** Provider reference with a one-click copy of the full value; long refs are shortened in the middle. */
const CopyableRef: React.FunctionComponent<{ value?: string | null }> = ({ value }) => {
  if (!value) return <>—</>;

  // Middle-truncate so support can still match both ends against the provider's back office.
  const display =
    value.length > MAX_LENGTH ? `${value.slice(0, HEAD_LENGTH)}…${value.slice(-TAIL_LENGTH)}` : value;

  const onCopy = () => {
    navigator.clipboard.writeText(value);
    toast.success(
      <div>
        คัดลอกรหัสอ้างอิงแล้ว
        <br />
        <div>{value}</div>
      </div>
    );
  };

  return (
    <span style={{ whiteSpace: "nowrap", display: "inline-flex", alignItems: "center", gap: 6 }}>
      <Tooltip title={value} mouseEnterDelay={0.5}>
        <span>{display}</span>
      </Tooltip>
      <Tooltip title="คัดลอก">
        <CopyOutlined style={{ cursor: "pointer" }} onClick={onCopy} />
      </Tooltip>
    </span>
  );
};

export default CopyableRef;
